export const publicLabsCatalog = {
  browseTitle: "Labs catalog",
  browseDescription: "Browse functional lab tests and panels.",
  browseSubtitle:
    "Search {{testCount}} tests from {{count}} lab company. Sign up as a practitioner to see pricing.",
  browseSubtitle_plural:
    "Search {{testCount}} tests from {{count}} lab companies. Sign up as a practitioner to see pricing.",
  companiesTitle: "Lab companies",
  companiesSubtitle: "{{count}} lab company available.",
  companiesSubtitle_plural: "{{count}} lab companies available.",
  companyPageTitle: "{{name}} lab tests",
  companyPageDescription: "Browse {{name}} lab tests. Sign up as a practitioner to see pricing.",
  companyTestsCount: "{{count}} test",
  companyTestsCount_plural: "{{count}} tests",
  logIn: "Sign in",
  signUp: "Create account",
  homeAriaLabel: "Fullscript",
  searchLabel: "Search",
  searchPlaceholder: "Search",
  companyFilter: "Company",
  companyFilterAll: "All",
  healthCategoryFilter: "Health category",
  healthCategoryFilterAll: "All",
  sampleTypeFilter: "Sample type",
  sampleTypeFilterAll: "All",
  sortLabel: "Sort",
  sortPopularity: "Most popular",
  sortBestMatch: "Best match",
  sortAlphabeticalAsc: "Alphabetical (A - Z)",
  sortAlphabeticalDesc: "Alphabetical (Z - A)",
  tableHeaderLabTest: "Lab test",
  tableHeaderSampleType: "Sample type",
  tableHeaderPrice: "Price",
  blurredPricePlaceholder: "$00.00",
  signUpToSeePrice: "Sign up to see price",
  emptyTitle: "No lab tests found",
  emptyDescription: "Try a different search or clear the filters.",
  emptyClearFilters: "Clear all filters",
  paginationPrevious: "Previous",
  paginationNext: "Next",
  paginationPage: "Page {{page}}",
  backToCatalog: "Back to catalog",
  detailDescription: "{{name}} from {{companyName}}.",
  patientTerm: "Patient",
  addOnsAvailable: "Add-ons available",
};
